import { toSecondPerson } from '~~/shared/organizations/secondPerson'

/**
 * The labels for the two synthetic buckets that name a document's home rather than a case or client
 * — "De tus conversaciones" and "De tus hojas".
 *
 * Extracted from `BrowserGroupedList.vue` when the finder had to name the same two buckets from
 * folders mode (AlexAmin/marcus#145). Two surfaces reading `second_person` and picking between the
 * same two keys is exactly how the tú/usted distinction gets half-applied: one of them eventually
 * hardcodes the informal string and the preference silently stops holding on that screen.
 *
 * Spanish needs *tus* or *sus*, and which is right is a fact about the person rather than their
 * country, so it comes from the profile's `second_person` — the same field the agent is told to
 * address the user by. Two variants cover three forms, because tú and vos share *tus*; English has
 * one second person, so both keys hold the same string.
 */
export function useSyntheticGroupLabels() {
  const { t } = useI18n()
  const { profile } = useUserProfile()

  const formal = computed(() => toSecondPerson(profile.value?.second_person) === 'usted')
  const conversationsLabel = computed(() => formal.value
    ? t('browser.groups.fromConversationsFormal')
    : t('browser.groups.fromConversations'))
  const sheetsLabel = computed(() => formal.value
    ? t('browser.groups.fromSheetsFormal')
    : t('browser.groups.fromSheets'))

  return { conversationsLabel, sheetsLabel }
}
